// RHVacacionesComponent.tsx
import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  Form,
  Row,
  Col,
  Modal,
  Accordion, 
} from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import CatVacaciones from '../../../Services/Catalogos/CatVacaciones';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';
import DTOPresolicitud from './DTO/DTOPresolicitud';
import DTOEmpleado from '../CatEmpleados/DTO/DTOEmpleado';
import DTOVacaciones from './DTO/DTOVacaciones';
import DTOInsertVacaciones from './DTO/DTOInsertVacaciones';
import { BsPencil } from 'react-icons/bs';
import { IconContext } from 'react-icons';

import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import PreRegistros from './DTO/PreRegistros';
import { EmpleadoVacacionesDTO } from './DTO/EmpleadoVacacionesDTO';
import * as XLSX from "xlsx";
import { FaTrash } from 'react-icons/fa';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const RHVacacionesComponent: React.FC = () => {
  // — Selección de empleado —
  const [empleados, setEmpleados] = useState<DTOEmpleado[]>([]);
  const [selectedEmpleado, setSelectedEmpleado] = useState<string>('');

  // — Datos existentes —
  const [vacaciones, setVacaciones] = useState<DTOVacaciones[]>([]);

  // — Modal de días salteados —
  const [showModal, setShowModal] = useState(false);
  const [selectedDays, setSelectedDays] = useState<Date[]>([]);
  const [currentVacacion, setCurrentVacacion] = useState<Partial<DTOVacaciones>>({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState<Partial<DTOInsertVacaciones>>({});

  // — Modal de solicitud especial —
  const [showSpecialModal, setShowSpecialModal] = useState(false);
  const [specialDaysToPay, setSpecialDaysToPay] = useState<number>(0);
  const [showSpecialConfirmModal, setShowSpecialConfirmModal] = useState(false);
  const [specialConfirmData, setSpecialConfirmData] = useState<{ numEmpleado: string; diasPagar: number }>({ numEmpleado: '', diasPagar: 0 });
 const [specialObservaciones, setSpecialObservaciones] = useState('');
  // — Toast informativo —
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [header, setHeader] = useState('');
  const [editModal, setEditModal] = useState(false);
const [vacacionSeleccionada, setVacacionSeleccionada] = useState<DTOVacaciones | null>(null);
const [filtroEmpleado, setFiltroEmpleado] = useState('');
const [paraAnioSiguiente, setParaAnioSiguiente] = useState(false);

const [preregistrosAnioSiguiente, setPreregistrosAnioSiguiente] = useState<PreRegistros[]>([]);
const [mostrarTablaPreregistros, setMostrarTablaPreregistros] = useState(false);
const [showDiaPagoCalendar, setShowDiaPagoCalendar] = useState<boolean>(false);





const [mostrarConcentrado, setMostrarConcentrado] = useState(false);

const [concentradoVacaciones, setConcentradoVacaciones] = useState<EmpleadoVacacionesDTO[]>([]); // Para almacenar los datos del concentrado


const [filtroConcentrado, setFiltroConcentrado] = useState('');


const concentradoFiltrado = concentradoVacaciones.filter((e) =>
  `${e.numEmpleado} ${e.nombre}`.toLowerCase().includes(filtroConcentrado.toLowerCase())
);
const formatearFecha = (fecha: string) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    const dia = date.getDate().toString().padStart(2, '0');
    const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11
    const anio = date.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };

const obtenerConcentradoVacaciones = async () => {
  try {
    const response = await CatVacaciones.getAllConcentradoVacaciones();
    
    if (response.data.length === 0) {
      setMsg('No hay solicitudes de vacaciones disponibles.');
      setHeader('Informativo');
      setShowMsg(true);  // Mostrar mensaje informativo
    } else {
      setConcentradoVacaciones(response.data);  // Guardar datos en el estado
      setMostrarConcentrado(true);

    }
  } catch (error) {
    console.error('Error al cargar concentrado de vacaciones:', error);
    setHeader('Error');
    setMsg('Hubo un problema al obtener el concentrado de vacaciones.');
    setShowMsg(true);  // Mostrar mensaje de error
  }
};



const columnsConcentradoVacaciones = [
  { name: 'NumEmpleado', selector: (row: EmpleadoVacacionesDTO) => row.numEmpleado, sortable: true, width: '130px' },
  { name: 'Nombre', selector: (row: EmpleadoVacacionesDTO) => row.nombre, sortable: true, width: '180px' },
  { name: 'Fecha Ingreso', selector: (row: EmpleadoVacacionesDTO) => formatearFecha(row.fechaIngreso), sortable: true, width: '150px' },
  { name: 'Próximo Aniversario', selector: (row: EmpleadoVacacionesDTO) =>  formatearFecha(row.proximoAniversario)   ,  sortable: true, width: '170px' },
  { name: 'Años Servicio', selector: (row: EmpleadoVacacionesDTO) => row.anosServicio, sortable: true, width: '130px' },
  { name: 'Días Vacaciones', selector: (row: EmpleadoVacacionesDTO) => row.diasPermitidos, sortable: true, width: '150px' },
  { name: 'Días Tomados', selector: (row: EmpleadoVacacionesDTO) => row.diasTomados, sortable: true, width: '130px' },
  { name: 'Días Pagados', selector: (row: EmpleadoVacacionesDTO) => row.diasYaPagados, sortable: true, width: '130px' },
  // { name: 'Dias que se pagara', selector: (row: EmpleadoVacacionesDTO) => row.diaPago, sortable: true, width: '130px'  }, 
  { name: 'Días Restantes', selector: (row: EmpleadoVacacionesDTO) => row.diasRestantes, sortable: true, width: '150px' },
  { name: 'Días por Pagar', selector: (row: EmpleadoVacacionesDTO) => row.diasPorPagar, sortable: true, width: '130px' },
];





const downloadExcelConcentrado = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Concentrado Vacaciones', {
    properties: { defaultColWidth: 15, defaultRowHeight: 18 },
  });

  const nombreArchivo = `Concentrado_Vacaciones_${new Date().toLocaleDateString('es-MX', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })}.xlsx`;

  // 1. LOGO GEMCO (igual que tu ejemplo)
  try {
    const response = await fetch('/GEMCO.png');
    if (response.ok) {
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();
      const logoId = workbook.addImage({
        buffer: arrayBuffer,
        extension: 'png',
      });
      worksheet.addImage(logoId, {
        tl: { col: 0.5, row: 0.5 },
        ext: { width: 140, height: 80 },
      });
    }
  } catch (e) {
    console.warn("Logo no encontrado");
  }

  // 2. Títulos grandes
  worksheet.mergeCells('B2:I2');
  const title = worksheet.getCell('B2');
  title.value = 'GLAFIRO E. MONTEMAYOR Y CIA S.C.';
  title.font = { bold: true, size: 18, color: { argb: 'FF000000' } };
  title.alignment = { horizontal: 'center', vertical: 'middle' };

  worksheet.mergeCells('B3:I3');
  const subtitle = worksheet.getCell('B3');
  subtitle.value = 'CONCENTRADO DE VACACIONES - RH';
  subtitle.font = { bold: true, size: 14, color: { argb: 'FF1A3C6D' } };
  subtitle.alignment = { horizontal: 'center', vertical: 'middle' };

  // Fecha de generación
  worksheet.getCell('B5').value = 'Generado el:';
  worksheet.getCell('C5').value = new Date().toLocaleString('es-MX', {
    dateStyle: 'long',
    timeStyle: 'short',
  });
  worksheet.getCell('C5').font = { italic: true, size: 10 };

  // 3. Encabezados (fila 8)
  const headerRow = 8;
  const headers = [
    'Num. Empleado',
    'Nombre',
    'Fecha Ingreso',
    'Próximo Aniversario',
    'Años Servicio',
    'Días Vacaciones',
    'Días Tomados',
    'Días Pagados',
    'Días Restantes',
    'Días por Pagar',
  ];

  headers.forEach((header, index) => {
    const cell = worksheet.getCell(headerRow, index + 2); // Empieza en columna B
    cell.value = header;
    cell.font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1A3C6D' } };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // 4. Datos (a partir de fila 9)
  let currentRow = headerRow + 1;
  concentradoFiltrado.forEach((emp) => {
    const row = worksheet.getRow(currentRow);

    row.values = [
      null, // margen A
      emp.numEmpleado,
      emp.nombre,
      formatearFecha(emp.fechaIngreso),
      formatearFecha(emp.proximoAniversario),
      emp.anosServicio,
      emp.diasPermitidos,
      emp.diasTomados,
      emp.diasYaPagados,
      emp.diasRestantes,
      emp.diasPorPagar,
    ];

    // WrapText en columnas largas (Nombre, etc.)
    row.getCell(3).alignment = { wrapText: true, vertical: 'middle' }; // Nombre

    // Color condicional en "Días Restantes" bajos
   

    // Bordes en toda la fila
    row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 2) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      }
    });

    currentRow++;
  });

  // 5. Ajuste automático de ancho de columnas (mejorado)
  

  // 6. Leyenda al final
  const leyendaRow = currentRow + 3;
  
  worksheet.getCell(leyendaRow + 2, 2).value = 'Generado desde sistema RH - RH';
  worksheet.getCell(leyendaRow + 2, 2).font = { italic: true, size: 9 };

  // 7. Descargar
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, nombreArchivo);
};





 
  const columnsVacaciones = [
    
    { name: 'NumEmpleado', selector: (row: DTOVacaciones) => row.numEmpleado, sortable: true, width: '130px' },
       
//     {
//   name: 'Fecha Ingreso',
//   selector: (row: DTOVacaciones) => { // Especificamos el tipo del parámetro 'row'
//     const fecha = new Date(row.fechaIngreso);
//     const day = fecha.getDate().toString().padStart(2, '0');
//     const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
//     const year = fecha.getFullYear();
//     return `${day}-${month}-${year}`;
//   },
//   sortable: true,
//   width: '130px'
// },

    // { name: 'Años Servicio', selector: (row: DTOVacaciones) => row.anosServicio, sortable: true, width: '130px' },
    // {name:  'Dias De vacaciones ', selector: (row: DTOVacaciones) => row.diasVacaciones, sortable: true, width: '150px' },
    {
  name: 'Días Disfrutados',
  width: '180px',
  selector: () => '', // dejarlo vacío para que no use este valor en la tabla
  cell: (row: DTOVacaciones) => {
    const dias = Array.isArray(row.diasSalteados)
      ? row.diasSalteados.join(', ')
      : typeof row.diasSalteados === 'string'
        ? row.diasSalteados
        : '';

    return (
      <div
        title={dias}
        onDoubleClick={() => alert(`Días Disfrutados:\n${dias}`)}
        style={{ cursor: 'pointer' }}
      >
        {dias.length > 30 ? dias.slice(0, 30) + '...' : dias}
      </div>
    );
  },
  sortable: false,
},


    { name: 'Días tomar ', selector: (r: DTOVacaciones) => r.diasTomar, sortable: true, width: '130px'},
    { name: 'Días a Pagar', selector: (r: DTOVacaciones) => r.diasPagar, sortable: true, width: '130px' },
    {
          name: 'Día que se Pagará',
          selector: (row: DTOVacaciones) => {
            if (!row.diaPago) return '—';
        
            try {
              // Detecta si viene como DateTime string tipo "11/13/2025 12:00:00 AM"
              const dateValue =
                typeof row.diaPago === 'string'
                  ? new Date(row.diaPago.replace(' AM', '').replace(' PM', '')) // limpia hora
                  : new Date(row.diaPago);
        
              // Evita Invalid Date
              if (isNaN(dateValue.getTime())) return '—';
        
              return dateValue.toLocaleDateString('es-MX', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              });
            } catch {
              return '—';
            }
          },
          sortable: true,
          width: '150px',
        },




    {
  name: 'Observaciones',
  width: '180px',
  selector: () => '',
  cell: (row: DTOVacaciones) => (
    <div
      title={row.observaciones}
      onDoubleClick={() => alert(`Observaciones:\n${row.observaciones}`)}
      style={{ cursor: 'pointer' }}
    >
      {row.observaciones && row.observaciones.length > 30
        ? row.observaciones.slice(0, 30) + '...'
        : row.observaciones}
    </div>
  ),
  sortable: true,
},

    // { name: 'Estado', selector: (r: DTOVacaciones) => r.estado, sortable: true },
    {
  name: 'Estado',
  cell: (r: DTOVacaciones) => (
    <span
      style={{
        padding: '4px 8px',
        borderRadius: '12px',
        fontWeight: 'bold',
        color: 'white',
        backgroundColor:
          r.estado === 'Aceptado' ? 'green' :
          r.estado === 'Pendiente' ? 'orange' :
          r.estado === 'Rechazado' ? 'red' : 'gray'
      }}
    >
      {r.estado}
    </span>
  ),
  sortable: true, width: '130px'
}, 

    { name: 'Dias Restantes', selector: (row: DTOVacaciones) => row.diasRestantes, sortable: true, width: '150px' },
    { name: 'Dias por pagar', selector: (row: DTOVacaciones) => row.diasPorPagar, sortable: true, width: '130px' },
    {
  name: 'Editar',
  cell: (row: DTOVacaciones) => (
    <IconContext.Provider value={{ color: 'blue', size: '16px' }}>
      <BsPencil
  style={{
    cursor: 'pointer',
    color: 'blue',
  }}
  onClick={() => {
    setVacacionSeleccionada(row);
    setEditModal(true);
  }}
/>

    </IconContext.Provider>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
}, 





  ];
  
  const cargarVacacionesEmpleado = async (numEmpleado: string) => {
  try {
    const response = await CatVacaciones.GetAllVacacionesAndDetalle(numEmpleado);
    setVacaciones(response.data);
  } catch (error) {
    console.error('Error al cargar vacaciones:', error);
  }
  };


  const confirmarEliminarPreregistro = (id: number) => {
  if (!window.confirm(`¿Estás seguro de que deseas eliminar el preregistro con ID ${id}?`)) {
    return;
  }

  CatVacaciones.EliminarPreRegistro(id)
    .then(res => {
      setHeader('Informativo');
      setMsg(res.data.mensaje || 'Eliminado correctamente');
      setShowMsg(true);

      // Refrescar lista de preregistros
      obtenerPreregistrosAnioSiguiente();
    })
    .catch(err => {
      setHeader('Error');
      setMsg(err.response?.data?.mensaje || 'Error al eliminar el preregistro');
      setShowMsg(true);
    });
};



const columnsPreregistros = [
  { name: 'ID', selector: (row: PreRegistros) => row.idPreSolicitud, sortable: true, width: '80px' },
  { name: 'NumEmpleado', selector: (row: PreRegistros) => row.numEmpleado, sortable: true },
  { name: 'Tipo Solicitud', selector: (row: PreRegistros) => row.tipoSolicitud, sortable: true },
  { name: 'Días Solicitados', selector: (row: PreRegistros) => row.diasSolicitados, sortable: true },
  { name: 'Días a Pagar', selector: (row: PreRegistros) => row.diasPagar, sortable: true },
  // { name: 'Fecha Inicio', selector: (row: PreRegistros) => row.fechaInicio ?? '—', sortable: true },
  // { name: 'Fecha Fin', selector: (row: PreRegistros) => row.fechaFin ?? '—', sortable: true },
  {
    name: 'Días Salteados',
    selector: () => '',
    cell: (row: PreRegistros) => (
      <div
        title={row.diasSalteados}
        onDoubleClick={() => alert(`Días Salteados:\n${row.diasSalteados}`)}
        style={{ cursor: 'pointer' }}
      >
        {row.diasSalteados.length > 30
          ? row.diasSalteados.slice(0, 30) + '...'
          : row.diasSalteados}
      </div>
    ),
    sortable: false
  },
  { name: 'Observaciones', selector: (row: PreRegistros) => row.observaciones,   cell: (row: PreRegistros) => (
    <div
      title={row.observaciones}
      onDoubleClick={() => alert(`Observaciones:\n${row.observaciones}`)}
      style={{ cursor: 'pointer' }}
    >
      {row.observaciones && row.observaciones.length > 30
        ? row.observaciones.slice(0, 30) + '...'
        : row.observaciones}
    </div>
  ),   sortable: false },
  {
    name: 'Estado',
    selector: (row: PreRegistros) => row.estado,
    sortable: true,
    cell: (row: PreRegistros) => (
      <span
        style={{
          padding: '4px 8px',
          borderRadius: '12px',
          fontWeight: 'bold',
          color: 'white',
          backgroundColor:
            row.estado === 'Aceptado' ? 'green' :
            row.estado === 'Pendiente' ? 'orange' :
            row.estado === 'Rechazado' ? 'red' : 'gray'
        }}
      >
        {row.estado}
      </span>
    )
  },
  {
    name: 'Procesado',
    selector: (row: PreRegistros) => row.procesado ? 'Sí' : 'No',
    sortable: true
  },
  {
    name: 'Fecha Creación',
    selector: (row: PreRegistros) => new Date(row.fechaCreacion).toLocaleString(),
    sortable: true
  }, 

  

{
  name: 'Eliminar',
  cell: (row: PreRegistros) => (
    <FaTrash
      title="Eliminar preregistro"
      style={{ cursor: 'pointer', color: 'red' }}
      onClick={() => confirmarEliminarPreregistro(row.idPreSolicitud)}
    />
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
  width: '100px'
}, 

];

  const obtenerPreregistrosAnioSiguiente = async () => {
  try {
    const response = await CatVacaciones.GetPreRegistrosAnioSiguiente(); // Llama al método del servicio
    setPreregistrosAnioSiguiente(response.data);
    setMostrarTablaPreregistros(true);
  } catch (error) {
    console.error('Error al obtener preregistros del año siguiente:', error);
    setHeader('Error');
    setMsg('No se pudieron cargar los preregistros.');
    setShowMsg(true);
  }
};


  // Carga lista de empleados
  useEffect(() => {
    CatEmpleados.GetAllEmpleado()
      .then(r => setEmpleados(r.data))
      .catch(console.error);
  }, []);

  
  useEffect(() => {
  // Solo refrescamos si el concentrado está a la vista
  if (mostrarConcentrado) {
    // Usamos un pequeño delay o simplemente la llamada
    obtenerConcentradoVacaciones();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [vacaciones]); // <--- Escucha cambios en la lista de vacaciones




  useEffect(() => {
  if (!selectedEmpleado) return;
  cargarVacacionesEmpleado(selectedEmpleado.replace(/"/g, ''));
}, [selectedEmpleado]);


  // Abre modal de días salteados
  const abrirModal = (vac?: DTOVacaciones) => {
    if (!selectedEmpleado) {
      setHeader('Error'); setMsg('Selecciona primero un empleado.'); setShowMsg(true);
      return;
    }
    if (vac) {
      setCurrentVacacion({ numEmpleado: selectedEmpleado, diasPagar: vac.diasPagar });
      const arr = Array.isArray(vac.diasSalteados)
        ? vac.diasSalteados
        : typeof vac.diasSalteados === 'string'
          ? vac.diasSalteados.split(',').map(s => s.trim())
          : [];
      setSelectedDays(arr.map(s => new Date(s)));
    } else {
      setCurrentVacacion({ numEmpleado: selectedEmpleado, diasPagar: 0 });
      setSelectedDays([]);
    }
    setShowModal(true);
  };

  // Prepara confirmación
  const mostrarConfirmacion = () => {
    setConfirmData({
      numEmpleado: selectedEmpleado,
      tipoSolicitud: 'VacacionesPorDisfrutar',
      fechaInicio: '',
      fechaFin: '',
      diasSolicitados: selectedDays.length,
      diasPagar: currentVacacion.diasPagar || 0,
      diasSalteados: selectedDays.map(d => d.toISOString().split('T')[0]),
      observaciones: currentVacacion.observaciones, 
      diaPago: currentVacacion.diaPago || null
      
    });
    setShowConfirmModal(true);
  };

  // Guarda días salteados
  const guardarVacacion = async (): Promise<void> => {
    if (selectedDays.length === 0) {
      setHeader('Error'); setMsg('Debes seleccionar al menos un día.'); setShowMsg(true);
      return;
    }
    

    const DTOInsertVacaciones = {
      numEmpleado: selectedEmpleado,
      tipoSolicitud: 'VacacionesPorDisfrutar',
      fechaInicio: '',
      fechaFin: '',
      diasSolicitados: selectedDays.length,
      diasPagar: currentVacacion.diasPagar || 0,
      diasSalteados: selectedDays.map(d => d.toISOString().split('T')[0]),
      estado:'Aceptado', 
      observaciones: currentVacacion.observaciones ?? '' , 
      diaPago: currentVacacion.diaPago || null,
    };

    

        try {
      const resp = paraAnioSiguiente
        ? await CatVacaciones.PostVacacionesAnioSiguiente(DTOInsertVacaciones)
        : await CatVacaciones.PostInsertVacaciones(DTOInsertVacaciones);

      if (resp.status === 200) {
        setHeader('Informativo'); 
        setMsg('Vacación guardada correctamente.');
        setShowMsg(true);
        setShowConfirmModal(false); 
        setShowModal(false);
        await cargarVacacionesEmpleado(selectedEmpleado.replace(/"/g, ''));
      }
    } catch (e: any) {
      setHeader('Error'); 
      setMsg(e.response?.data?.message || 'Error al procesar la solicitud.');
      setShowMsg(true);
    }

        if (mostrarConcentrado) {
      await obtenerConcentradoVacaciones();
    }


  };

  // Solicitud especial
  const abrirSpecialModal = () => { setSpecialConfirmData({ numEmpleado: selectedEmpleado, diasPagar: 0 }); setSpecialDaysToPay(0); setShowSpecialModal(true); };
  const handleSpecialRequest = () => {
    if (specialDaysToPay <= 0) { setHeader('Error'); setMsg('Ingresa un número válido de días a pagar.'); setShowMsg(true); return; }
    setSpecialConfirmData({ numEmpleado: selectedEmpleado, diasPagar: specialDaysToPay });
    setShowSpecialConfirmModal(true);
  };
  const confirmSpecialRequest = async () => {
    const DTOInsertVacaciones= {
    //   id: 0,
      numEmpleado: specialConfirmData.numEmpleado,
      tipoSolicitud: 'SoloDiasPago',
      fechaInicio: '', fechaFin: '',
      diasPagar: specialConfirmData.diasPagar,
      diasSolicitados: 0, diasSalteados: [],
      estado: 'Aceptado', 
      observaciones: specialObservaciones, 
      diaPago: currentVacacion.diaPago || null,
    };
    try {
      const resp = await CatVacaciones.PostInsertVacaciones(DTOInsertVacaciones);
      if (resp.status === 200) {
        setHeader('Informativo'); setMsg('Solicitud especial enviada.'); setShowMsg(true);
        setShowSpecialConfirmModal(false); setShowSpecialModal(false);
        // const all = await CatVacaciones.GetAllVacaciones(selectedEmpleado.replace(/"/g, ''));
        // setVacaciones(all.data);
        await cargarVacacionesEmpleado(selectedEmpleado.replace(/"/g, ''));

      }
    } catch (e: any) {
      setHeader('Error'); setMsg(e.response?.data?.message || 'Error al procesar la solicitud especial.'); setShowMsg(true);
    }

        if (mostrarConcentrado) {
      await obtenerConcentradoVacaciones();
    }

  };

  

  return (

    <div>
      {/* Selección y acciones */}
      <Card className="mb-4">
        <Card.Body>
          <Row className="align-items-end">
            <Col md={4}>
              

<Form.Control
      type="text"
      placeholder="Buscar por nombre o número"
      value={filtroEmpleado}
      onChange={(e) => setFiltroEmpleado(e.target.value)}
      className="mb-2"
    />
    <Form.Control
      as="select"
      value={selectedEmpleado}
      onChange={(e) => setSelectedEmpleado(e.target.value)}
      style={{ height: '38px' }}
    >
      <option value="">-- Seleccionar --</option>
      {empleados
        .filter((e) =>
          `${e.numEmpleado} ${e.name}`.toLowerCase().includes(filtroEmpleado.toLowerCase())
        )
        .map((e) => (
          <option key={e.numEmpleado} value={e.numEmpleado}>
            {e.numEmpleado} — {e.name}
          </option>
        ))}
    </Form.Control>


            </Col>
            <Col xs="auto">
              <Button onClick={() => abrirModal()} disabled={!selectedEmpleado}>+ Días a Disfrutar</Button>
            </Col>
            <Col xs="auto">
              <Button variant="warning" onClick={abrirSpecialModal} disabled={!selectedEmpleado}>Solicitud Especial</Button>
            </Col>

            <Col xs="auto">
  <Button variant="info" onClick={obtenerPreregistrosAnioSiguiente}>
    Ver Preregistros de vacacioes
  </Button>
</Col>

<Col xs="auto">
  <Button variant="info" onClick={obtenerConcentradoVacaciones}>
    Ver Concentrado
  </Button>
</Col>


          </Row>
        </Card.Body>
      </Card>

      {/* Tabla */}
      <Card className="mb-4">
        <Card.Header>Solicitudes de Vacaciones</Card.Header>
        <Card.Body>
          <DataTable columns={columnsVacaciones} data={vacaciones} pagination highlightOnHover />
        </Card.Body>
      </Card>

      {/* Modal Días Salteados */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton><Modal.Title>Días a Disfrutar</Modal.Title></Modal.Header>
        <Modal.Body>
          <Calendar
            onClickDay={d => {
              const exists = selectedDays.some(x => x.getTime() === d.getTime());
              setSelectedDays(exists ? selectedDays.filter(x => x.getTime() !== d.getTime()) : [...selectedDays, d]);
            }}
            tileClassName={({ date }) => selectedDays.some(x => x.getTime() === date.getTime()) ? 'selected-day' : ''}
          />
          
<div className="mt-2">
  <strong>Días seleccionados: {selectedDays.length}</strong>
  <ul className="mb-0">
    {selectedDays
      .sort((a, b) => a.getTime() - b.getTime()) 
      .map((d, i) => (
        <li key={i}>{d.toLocaleDateString()}</li>
      ))}
  </ul>
</div>

          
          <Form.Group className="mt-3">
            <Form.Label>Días a Pagar</Form.Label>
            <Form.Control
              type="number"
              min={0}
              value={currentVacacion.diasPagar || ''}
              onChange={e => setCurrentVacacion(prev => ({ ...prev, diasPagar: Number(e.target.value) }))}
            />
          </Form.Group>

            
  
          

          <Form.Group className="mt-3">
  <Form.Label>Día de Pago</Form.Label>

  <div style={{ position: 'relative' }}>
    <Form.Control
      type="text"
      readOnly
      value={
        currentVacacion.diaPago
          ? new Date(currentVacacion.diaPago + 'T00:00:00').toLocaleDateString('es-MX', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : ''
      }
      placeholder="Seleccionar fecha de pago"
      onClick={() => setShowDiaPagoCalendar((prev) => !prev)}
      style={{ cursor: 'pointer' }}
    />

    {showDiaPagoCalendar && (
      <div
        style={{
          position: 'absolute',
          zIndex: 9999,
          background: 'white',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
          borderRadius: '8px',
          padding: '8px',
          marginTop: '5px',
        }}
      >
        <Calendar
          onClickDay={(date) => {
            const localDate = new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            )
              .toISOString()
              .split('T')[0];

            setCurrentVacacion((prev) => ({
              ...prev,
              diaPago: prev.diaPago === localDate ? null : localDate,
            }));

            setShowDiaPagoCalendar(false);
          }}
          // 🔓 Ahora todas las fechas están habilitadas
          tileDisabled={() => false}
          tileClassName={({ date }) => {
            const localDate = new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            )
              .toISOString()
              .split('T')[0];
            return currentVacacion.diaPago === localDate ? 'selected-day' : '';
          }}
        />
      </div>
    )}
  </div>

  <Form.Text className="text-muted">
    Selecciona cualquier fecha para el pago.
  </Form.Text>
</Form.Group>


                                       
            











          

                       <Form.Group controlId="comentarioInput">
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={currentVacacion.observaciones || ''}
              onChange={(e) =>
                setCurrentVacacion((prevState) => ({
                  ...prevState,
                  observaciones: e.target.value,
                }))
              }
            />
          </Form.Group>
          
              <Form.Group className="mt-3">
  <Form.Check
    type="checkbox"
    label="Aplicar para el siguiente año de servicio"
    checked={paraAnioSiguiente}
    onChange={(e) => setParaAnioSiguiente(e.target.checked)}
  />
</Form.Group>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={mostrarConfirmacion}>Guardar</Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmación Días Salteados */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton><Modal.Title>Confirmar Días a Disfrutar</Modal.Title></Modal.Header>
        <Modal.Body>
          <p>Revisa tu selección antes de confirmar:</p>
          <ul>
            <li><strong>Empleado:</strong> {confirmData.numEmpleado}</li>
            <li><strong>Días Seleccionados:</strong> {confirmData.diasSalteados?.join(', ')}</li>
            <li><strong>Días a Pagar:</strong> {confirmData.diasPagar}</li>




               <li>
  <strong>Día de Pago:</strong>{' '}
  {confirmData.diaPago
    ? (() => {
        try {
          const dateValue = new Date(
            confirmData.diaPago.replace(/-/g, '/')
          ); // ✅ Forza interpretación local
          return isNaN(dateValue.getTime())
            ? '—'
            : dateValue.toLocaleDateString('es-MX', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              });
        } catch {
          return '—';
        }
      })()
    : '—'}
</li>

           

            <li><strong>Observaciones: </strong>{confirmData.observaciones}</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Atrás</Button>
          <Button variant="primary" onClick={guardarVacacion}>Confirmar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Especial */}
      <Modal show={showSpecialModal} onHide={() => setShowSpecialModal(false)}>
        <Modal.Header closeButton><Modal.Title>Solicitud Especial – Solo Días a Pagar</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Días a Pagar</Form.Label>
            <Form.Control type="number" min={0} value={specialDaysToPay} onChange={e => setSpecialDaysToPay(Number(e.target.value))} />
          </Form.Group>




<Form.Group className="mt-3">
  <Form.Label>Día de Pago</Form.Label>

  <div style={{ position: 'relative' }}>
    <Form.Control
      type="text"
      readOnly
      value={
        currentVacacion.diaPago
          ? new Date(currentVacacion.diaPago + 'T00:00:00').toLocaleDateString('es-MX', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : ''
      }
      placeholder="Seleccionar fecha de pago"
      onClick={() => setShowDiaPagoCalendar((prev) => !prev)}
      style={{ cursor: 'pointer' }}
    />

    {showDiaPagoCalendar && (
      <div
        style={{
          position: 'absolute',
          zIndex: 9999,
          background: 'white',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
          borderRadius: '8px',
          padding: '8px',
          marginTop: '5px',
        }}
      >
        <Calendar
          onClickDay={(date) => {
            const localDate = new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            )
              .toISOString()
              .split('T')[0];

            setCurrentVacacion((prev) => ({
              ...prev,
              diaPago: prev.diaPago === localDate ? null : localDate,
            }));

            setShowDiaPagoCalendar(false);
          }}
          // 🔓 Ahora todas las fechas están habilitadas
          tileDisabled={() => false}
          tileClassName={({ date }) => {
            const localDate = new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            )
              .toISOString()
              .split('T')[0];
            return currentVacacion.diaPago === localDate ? 'selected-day' : '';
          }}
        />
      </div>
    )}
  </div>

  <Form.Text className="text-muted">
    Selecciona cualquier fecha para el pago.
  </Form.Text>
</Form.Group>







            <Form.Group controlId="observacionesEspecial">
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={specialObservaciones}
              onChange={(e) => setSpecialObservaciones(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSpecialModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleSpecialRequest}>Enviar Solicitud</Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmación Especial */}
      <Modal show={showSpecialConfirmModal} onHide={() => setShowSpecialConfirmModal(false)}>
        <Modal.Header closeButton><Modal.Title>Confirmar Solicitud Especial</Modal.Title></Modal.Header>
        <Modal.Body>
          <p>¿Confirmas pagar <strong>{specialConfirmData.diasPagar}</strong> días de vacaciones?</p>
          <li><strong>Días a Pagar:</strong> {specialConfirmData.diasPagar}</li>



    <li>
  <strong>Día de Pago:</strong>{' '}
  {currentVacacion.diaPago
    ? (() => {
        try {
          const dateValue = new Date(
            currentVacacion.diaPago.replace(/-/g, '/')
          ); // ✅ evita desplazamiento UTC
          return isNaN(dateValue.getTime())
            ? '—'
            : dateValue.toLocaleDateString('es-MX', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              });
        } catch {
          return '—';
        }
      })()
    : '—'}
</li>




        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSpecialConfirmModal(false)}>Atrás</Button>
          <Button variant="primary" onClick={confirmSpecialRequest}>Confirmar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={editModal} onHide={() => setEditModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Editar Estado de Solicitud</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group controlId="estadoSelect">
        <Form.Label>Estado</Form.Label>
        <Form.Control
          as="select"
          value={vacacionSeleccionada?.estado || ''}
          onChange={(e) =>
            setVacacionSeleccionada((prev) =>
              prev ? { ...prev, estado: e.target.value } : null
            )
          }
        >
          <option value="Pendiente">Pendiente</option>
          <option value="Aceptado">Aceptado</option>
          <option value="Rechazado">Rechazado</option>
        </Form.Control>
      </Form.Group>
      <Form.Group controlId="comentarioInput" className="mt-3">
        <Form.Label>Comentario</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={vacacionSeleccionada?.comentario || ''}
          onChange={(e) =>
            setVacacionSeleccionada((prev) =>
              prev ? { ...prev, comentario: e.target.value } : null
            )
          }
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setEditModal(false)}>Cancelar</Button>
   

    <Button
  variant="primary"
  onClick={async () => {
    if (!vacacionSeleccionada) return;

    try {
      if (vacacionSeleccionada.estado === 'Rechazado') {
        const deleteData = {
          id: vacacionSeleccionada.id,
          numEmpleado: vacacionSeleccionada.numEmpleado,
          FechaRegistro: vacacionSeleccionada.fechaSolicitud,
        };
        const response = await CatVacaciones.DeleteVacaciones(deleteData);
        setMsg(response.data.Message || 'Solicitud eliminada');

              if (mostrarConcentrado) {
          await obtenerConcentradoVacaciones();
        }
      } else {
        // const fechaAceptacion = new Date().toISOString();
        const fechaAceptacion = vacacionSeleccionada.estado === 'Aceptado'
  ? new Date().toLocaleString('sv-SE')
  : undefined;
        await CatVacaciones.putVacacionesEstado(
          vacacionSeleccionada.id,
          vacacionSeleccionada.estado,
          vacacionSeleccionada.comentario || '',
          fechaAceptacion
        );
        setMsg('Solicitud actualizada correctamente');
      }

      // ✅ Enviar notificación
      await CatVacaciones.enviarNotificacionVacaciones(
        vacacionSeleccionada.numEmpleado,
        vacacionSeleccionada.nombre,
        vacacionSeleccionada.correo,
        vacacionSeleccionada.estado,
        vacacionSeleccionada.comentario || ''
      );

     
      await cargarVacacionesEmpleado(vacacionSeleccionada.numEmpleado);

      setHeader('Informativo');
    } catch (err: any) {
      setMsg(err.response?.data?.message || 'Error al guardar');
      setHeader('Error');
    }

    setShowMsg(true);
    setEditModal(false);
    setVacacionSeleccionada(null);
  }}
>
  Guardar
</Button>

  </Modal.Footer>
</Modal>




{mostrarTablaPreregistros && (
  <Card className="mb-4">
    <Card.Header>
      <Row className="align-items-center">
        <Col><strong>Preregistros de Vacaciones</strong></Col>
        <Col xs="auto">
          <Button variant="outline-danger" size="sm" onClick={() => setMostrarTablaPreregistros(false)}>
            Cerrar
          </Button>
        </Col>
      </Row>
    </Card.Header>
    <Card.Body>
      <DataTable
        columns={columnsPreregistros}
        data={preregistrosAnioSiguiente}
        pagination
        highlightOnHover
      />
    </Card.Body>
  </Card>
)}


{mostrarConcentrado && (
  <Card className="mb-4">
    <Card.Header>
      <Row className="align-items-center">
        <Col><strong>Reporte de Vacaciones</strong></Col>
        <Col xs="auto">
          <Form.Control
            type="text"
            placeholder="Buscar por nombre o número"
            value={filtroConcentrado}
            onChange={(e) => setFiltroConcentrado(e.target.value)}
            size="sm"
          />
        </Col>

        <Col xs="auto">
  <Button variant="success" size="sm" onClick={downloadExcelConcentrado}>
    Exportar a Excel
  </Button>
</Col>

        <Col xs="auto">
          <Button variant="outline-danger" size="sm" onClick={() => setMostrarConcentrado(false)}>
            Cerrar
          </Button>
        </Col>
      </Row>
    </Card.Header>
    <Card.Body>
      <DataTable
        columns={columnsConcentradoVacaciones}
        data={concentradoFiltrado}
        pagination
        highlightOnHover
        dense
      />
    </Card.Body>
  </Card>
)}




      {/* Toast */}
      <MsgInformativo show={showMsg} header={header} msg={msg} msgColor={header === 'Error' ? 'danger' : 'primary'} closeToast={() => setShowMsg(false)} />
    </div>
  );
};

export default RHVacacionesComponent;
